class InputRotate extends HTMLElement {
    constructor() {
        super();
        this.slogans = Array.from(this.querySelectorAll('.c_input-wrap p'))
        this.components = this.querySelectorAll('.c_input-wrap, .rotate_controls')
        this.startPos = this.slogans.length - 1
        this.intervalID = 0
        this.hiddenElement = null
        this.dist = 0;
        this.duration = 1300
        this.rotation = 0
        this.programRunning = false


        this.startRotate = this.init()
        this.startRotate()
    }

    rotate() {
        const slogans = this.slogans
        const startPos = this.startPos
        slogans[startPos].style.transition = 'transform .7s ease-out'
        slogans[startPos].style.transform = slogans[startPos].id ? `translate(-50%, ${this.dist}%)` : `translate(0%, ${this.dist}%)`

        // Previous element
        if (this.dist == 100) {
            slogans[startPos - 1].style.transition = 'transform .7s ease-out'
            slogans[startPos - 1].style.transform = slogans[startPos].id ? `translate(-50%, ${this.dist - 100}%)` : `translate(0%, ${this.dist - 100}%)`
        }
        // When transformed below add element to begining of array
        if (this.dist === 200) {
            const lastItem = slogans.pop()
            lastItem.style.transition = 'none'
            lastItem.style.transform = null
            slogans.unshift(lastItem)
            this.dist = 0
        }

        this.dist += 100
        this.rotation++
    }

    init() {
        if (this.slogans.length > 1) {
            this.rotate()
            this.programRunning = true
            return () => this.intervalID = setInterval(() => {
                if (this.rotation++ >= 3) this.rotate()
            }, this.duration);
           // If only one slogan in the program don't run animation and make static 
        } else {
            return () => {
                this.slogans[0].style.transform = `translate(-50%, 0%)`
            }
        }
    }
}
customElements.define('input-rotate', InputRotate);